export const generateSecurePassword = (length = 12) => {
  const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lowercase = 'abcdefghijklmnopqrstuvwxyz';
  const numbers = '0123456789';
  const symbols = '!@#$%^&*()_+-=[]{}|;:,.<>?';
  
  const allChars = uppercase + lowercase + numbers + symbols;
  
  let password = '';
  
  password += uppercase[Math.floor(Math.random() * uppercase.length)];
  password += lowercase[Math.floor(Math.random() * lowercase.length)];
  password += numbers[Math.floor(Math.random() * numbers.length)];
  password += symbols[Math.floor(Math.random() * symbols.length)];
  
  for (let i = 4; i < length; i++) {
    password += allChars[Math.floor(Math.random() * allChars.length)];
  }
  
  return password
    .split('')
    .sort(() => Math.random() - 0.5)
    .join('');
};

export const generateUserFriendlyPassword = () => {
  const adjectives = [
    'Happy', 'Bright', 'Swift', 'Smart', 'Strong', 'Kind', 'Bold', 'Quick',
    'Wise', 'Clear', 'Calm', 'Safe', 'Pure', 'Gold', 'Blue', 'Green'
  ];
  
  const nouns = [
    'Lion', 'Eagle', 'Tiger', 'Bear', 'Wolf', 'Hawk', 'Star', 'Ocean',
    'Mountain', 'River', 'Tree', 'Stone', 'Fire', 'Wind', 'Rain', 'Snow'
  ];
  
  const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const noun = nouns[Math.floor(Math.random() * nouns.length)];
  const number = Math.floor(Math.random() * 999) + 1;
  
  return `${adjective}${noun}${number}`;
};

export const validatePasswordStrength = (password) => {
  const minLength = 8;
  const hasUppercase = /[A-Z]/.test(password);
  const hasLowercase = /[a-z]/.test(password);
  const hasNumbers = /\d/.test(password);
  const hasSpecialChar = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password);
  
  const score = [
    password.length >= minLength,
    hasUppercase,
    hasLowercase,
    hasNumbers,
    hasSpecialChar
  ].filter(Boolean).length;
  
  return {
    score,
    isValid: score >= 4,
    feedback: {
      length: password.length >= minLength,
      uppercase: hasUppercase,
      lowercase: hasLowercase,
      numbers: hasNumbers,
      special: hasSpecialChar
    }
  };
};

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    console.error('Failed to copy to clipboard:', err);
    
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.select();
    
    try {
      document.execCommand('copy');
      document.body.removeChild(textArea);
      return true;
    } catch (fallbackErr) {
      console.error('Fallback copy failed:', fallbackErr);
      document.body.removeChild(textArea);
      return false;
    }
  }
};